import React from 'react';
import Services1Header from '../components/ServicesComponents/Services1Header';
import CallToAction from '../components/Misc/CallToAction';
import ServicesSection from '../components/ServicesComponents/ServicesSection';
import Heading from '../components/Headers/Heading';
import TabsSection from '../components/Sections/TabsSection';

import Art from '../components/Misc/Art';
import art from '../assets/images/art_3.png';

function ServiceStyle2() {
    return (
        <>
            <Services1Header />
            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <h2 className="heading heading-very-large light-1 mb-4">How we work</h2>
                                <div className="paragraph light-1">
                                    <p>At DMA Foundation, we believe in a holistic, community-driven approach to mental health and rehabilitation. Our work begins with outreach—raising awareness, reducing stigma, and providing education about mental health in underserved communities. We collaborate with local leaders, schools, and organizations to identify those in need and ensure our services are accessible to all.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="paragraph light-1">
                                    <p>We focus on long-term impact by empowering individuals and families with tools for resilience and recovery. Our rehabilitation programs include therapy, skills training, and peer support, helping beneficiaries reintegrate into society and lead fulfilling lives. We also provide ongoing mentorship and follow-up to ensure sustained progress.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tab-section">
                <div className="tab-section-wrapper">
                    <div className="container">
                        <Heading 
                            heading={<h2>Discover more about our services</h2>}
                            headingClass="heading-very-large dark-1"
                            headingColumn="col-lg-9"
                        />
                        <TabsSection />
                    </div>
                </div>
            </div>
            <CallToAction 
                wrapperClass='bg-main'
                heading={
                    <>
                        Love to join us? 
                        <br />
                        Volunteer with us now
                    </>
                }
                buttonText="Volunteer Now"
                buttonLink="/get-involved"
                buttonType="2"
                artwork={<Art art={art} type={'4'} />}
            />
            <CallToAction 
                wrapperClass='projects-footer bg-black'
                headingClass='light-1'
                heading={
                    <>Need Support? Reach out today.</>
                }
                buttonText="Get Support"
                buttonLink="/contact"
                buttonType="1"
            />
        </>
    );
}

export default ServiceStyle2;
